/*
Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.

Licensed under the Apache License, Version 2.0 (the "License").
You may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/
import { RootState } from '@ink-ai/portal/reducers';
import { Card, CircularProgress, Modal, Typography, Alert, Box } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

export const SocketLoading: React.FC<{ variant?: 'modal' | 'inline' }> = ({ variant = 'inline' }) => {
  const webSocketState = useSelector((state: RootState) => state.webSocket);
  const { t } = useTranslation();
  if (webSocketState.connected) return null;
  // console.log('webSocketState', webSocketState, variant);
  if (variant === 'modal') {
    return (
      <Modal open>
        <Card
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 200,
            bgcolor: 'background.paper',
            p: 4,
          }}
        >
          <div className="flex flex-col items-center">
            <CircularProgress size={80} />
            <Typography variant="overline" sx={{ mt: 2 }}>
              {t('app.connecting')}
            </Typography>
          </div>
        </Card>
      </Modal>
    );
  }
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      {/* <Box sx={{ 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center', 
        gap: 1, 
        backgroundColor: 'background.paper', 
        margin: '0 24px',
        padding: '8px 16px',
      }}>
        <CircularProgress size={16} />
        {t('app.connecting')}
      </Box> */}
      <Alert severity="info" icon={<CircularProgress size={16} />}>
        {t('app.connecting')}
      </Alert>
    </Box>
  );
};
